export default "__VITE_ASSET__BeA_FcMQ__"